import OneTimeWirePage from "components/pages/OneTimeWirePage";
import { useEffect } from "react";

/**
 * @name CaptureOneTimeWireDefaultMenuOpen
 * @returns {React.Component}
 * @description 
 */
export default function CaptureOneTimeWireDefaultMenuOpen(props) {
    useEffect(() => {
        const link = document.querySelector(`[data-point="Nav_Wires"]  a`);
        if(link) {
            link.click();
        } else {
            document.write(`<div style='height: 100%; display: flex; align-items: center;justify-content: center;'><h1 style = ‘font-size:35px; text-align:center; vertical-align: middle;’>This capture is only shown when "Wires" is set to "Yes".</h1></div>`);
        }
    });
    return <OneTimeWirePage />;
}